import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "my-org-group-child-tree-node"
};
import { useAuthorStore } from '@/stores';

import { ref, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { fetchApi } from '/Users/ytx/ytx/projects/jxpj/web/jxpj-client/src/server/auto-import.js';
export default {
  __name: 'my-org-group-child-tree',
  emits: ['node-dblclick'],
  setup(__props, {
    emit: __emit
  }) {
    const treeRef = ref();
    const authorStore = useAuthorStore();
    const {
      org
    } = storeToRefs(authorStore);
    const list = ref([]);
    const emit = __emit;
    const {
      loading,
      runAsync: getChildTree
    } = fetchApi('myOrgGroup.getChildTree');
    const loadData = async () => {
      if (!org.value) {
        list.value = [];
        return Promise.resolve(true);
      }
      const {
        error,
        rows
      } = await getChildTree({});
      if (error) return Promise.resolve(false);
      const {
        id,
        name
      } = org.value;
      list.value = [{
        id,
        name,
        children: rows
      }];
    };
    const handleNodeDblclick = ({
      node,
      $event
    }) => {
      const isExpend = treeRef.value.isExpandByNode(node);
      if (!isExpend) {
        treeRef.value.setExpandNode(node, true);
      }
      emit('node-dblclick', {
        node,
        $event
      });
    };
    onMounted(() => {
      loadData();
    });
    return (_ctx, _cache) => {
      const _component_vxe_tree = _resolveComponent("vxe-tree");
      return _openBlock(), _createBlock(_component_vxe_tree, _mergeProps({
        ref_key: "treeRef",
        ref: treeRef
      }, _ctx.$attrs, {
        "title-field": "name",
        "key-field": "id",
        "children-field": "children",
        "parent-field": "parentId",
        data: _unref(list),
        loading: _unref(loading),
        "is-current": "",
        "is-hover": "",
        "show-line": "",
        "show-icon": "",
        "expand-all": true,
        "icon-open": "fa fa-folder-open-o",
        "icon-close": "fa fa-folder-o",
        trigger: "default",
        onNodeDblclick: handleNodeDblclick
      }), {
        title: _withCtx(({
          node
        }) => [_createElementVNode("span", _hoisted_1, _toDisplayString(node['name']), 1)]),
        _: 1
      }, 16, ["data", "loading"]);
    };
  }
};